<!-- Header bar: year + selected date (e.g. Duminică, 20 Ianuarie) -->
<div
  class="tw:flex tw:flex-col tw:gap-0.5 tw:bg-(--color-blue-main) tw:px-4 tw:py-3 tw:text-[rgba(255,255,255,0.95)]"
>
  <span class="tw:text-xs tw:opacity-85">{{ headerYear }}</span>
  <span class="tw:text-lg tw:font-semibold tw:tracking-wide">
    {{ headerDayKey | transloco }}, {{ headerDayOfMonth }}
    {{ headerMonthKey | transloco }}
  </span>
</div>
<!-- Navigation row -->
<div
  class="mat-calendar-header mat-calendar-controls tw:border-b tw:border-(--color-border-light) tw:bg-(--color-mid-gray) tw:m-0! tw:pt-2! tw:pb-2!"
>
  <span
    [id]="_periodButtonLabelId"
    class="cdk-visually-hidden"
    aria-live="polite"
  >
    {{ periodButtonDescription }}
  </span>
  <button
    mat-button
    type="button"
    class="mat-calendar-period-button tw:font-semibold tw:tracking-wide"
    (click)="currentPeriodClicked()"
    [attr.aria-label]="periodButtonLabel"
    [attr.aria-describedby]="_periodButtonLabelId"
  >
    <span aria-hidden="true">{{ periodButtonText }}</span>
    <svg
      class="mat-calendar-arrow"
      [class.mat-calendar-invert]="calendar.currentView !== 'month'"
      viewBox="0 0 10 5"
      focusable="false"
      aria-hidden="true"
    >
      <polygon points="0,0 5,5 10,0" />
    </svg>
  </button>

  <div class="mat-calendar-spacer"></div>

  <button
    mat-icon-button
    type="button"
    class="mat-calendar-previous-button tw:text-(--color-text)"
    [disabled]="!previousEnabled()"
    (click)="previousClicked()"
    [matTooltip]="prevButtonLabel"
    [attr.aria-label]="prevButtonLabel"
  >
    <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  </button>

  <button
    mat-icon-button
    type="button"
    class="mat-calendar-next-button tw:text-(--color-text)"
    [disabled]="!nextEnabled()"
    (click)="nextClicked()"
    [matTooltip]="nextButtonLabel"
    [attr.aria-label]="nextButtonLabel"
  >
    <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  </button>
</div>
